<template>
    <b-button
        variant="success"
        @click.stop="confirmarAssinaturaAdtivoContrato()"
        class="ml-1"
    >
        <span> <i class="fa fa-random mr-2"></i> Assinar Aditivo Contrato </span>
    </b-button>
</template>

<script>
import ContratosServicos from './ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAssinaturaAdtivoContrato() {
            this.$swal({
                title: 'Assinar Aditivo Contrato',
                html: `Confirma a assinatura do aditivo contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.assinarAditivoContrato()
                }
            })
        },

        assinarAditivoContrato() {
            this.$store.dispatch('addRequest')
            let contratoDto = {
                idContrato: this.contrato.idContrato
            }
            ContratosServicos.assinarAditivoContrato(contratoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Aditivo contrato distribuído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterContratoAtualizado')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
